/*** IMPORTS FROM imports-loader ***/
var jQuery = require("jquery");
var $ = require("jquery");

import 'aisztheme';
import React from 'react';
import {
  injectIntl,
} from 'react-intl';
import {
  Panel,
  Tooltip,
  OverlayTrigger,
} from 'react-bootstrap';
import CSSModules from 'react-css-modules';
import IntlMsg from 'lorautils/intl/IntlMsg';
import styles from './styles/main.scss';

const propTypes = {
  intl: React.PropTypes.any.isRequired,
  data: React.PropTypes.any,
  getData: React.PropTypes.func,
  keyName: React.PropTypes.string,
  valueName: React.PropTypes.string,
  valueTitleComponent: React.PropTypes.any,
  valueItem: React.PropTypes.string,
  withPanel: React.PropTypes.bool,
  formatKey: React.PropTypes.func,
  formatValue: React.PropTypes.func,
  onClickKey: React.PropTypes.func,
};

class Rank extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data || [],
      showHelpDoc: false,
    };
    this.intlMsg = new IntlMsg(props.intl, this.props.namespace);
  }

  componentDidMount() {
    if (this.props.getData) {
      this.props.getData(null).then((res) => {
        this.setState({data: res.body.list});
      });
    }
  }

  render() {
    const items = this.state.data;
    const element =
      (<div styleName="rank">
        <div styleName="list-tt">
          <span styleName="tt-index">{this.intlMsg.msg('rank')}</span>
          <span styleName="tt-key">{this.intlMsg.msg(this.props.keyName)}</span>
          <span styleName="tt-value">
          {this.props.valueTitleComponent || this.intlMsg.msg(this.props.valueName)}
        </span>
        </div>
        <ul styleName="item-list">
          {
            items.map((item, index) =>
              <li key={index}>
                <div styleName="item-hd">
                  <span styleName="item-index">{index + 1}</span>
                  <span styleName="item-key">
                    <a onClick={() => this.props.onClickKey(item)}>
                      {this.props.formatKey(item[this.props.keyName])}
                    </a>
                  </span>
                  <span styleName="item-value">
                    {this.props.formatValue(item[this.props.valueItem || this.props.valueName])}
                  </span>
                </div>
              </li>,
            )
          }
        </ul>
      </div>);
    if (this.props.withPanel) {
      const helpTooltip = <Tooltip id="tooltip-help">{this.intlMsg.msg(`${this.props.valueName}.help`)}</Tooltip>;
      const header = (
        <div>
        <span>
          {this.intlMsg.msg(this.props.valueName)}
        </span>
          <OverlayTrigger trigger="click" rootClose placement="right" overlay={helpTooltip}>
            <span className="glyphicons glyphicons-question-sign"/>
          </OverlayTrigger>
        </div>
      );
      return (<Panel bsStyle="aisz-white" header={header}>
        {element}
      </Panel>);
    }
    return element;
  }
}

Rank.defaultProps = {
  formatKey: key => key,
  formatValue: value => value,
};

Rank.propTypes = propTypes;

export default injectIntl(CSSModules(Rank, styles, {allowMultiple: true}));




// WEBPACK FOOTER //
// ./src/containers/Network/coms/NodeView/coms/Rank/index.jsx